import { React, useState, useContext, useEffect } from 'react'
import Loading from "react-fullscreen-loading";
import HeaderSection from "../banner/HeaderSection";
import * as  CONST from "../../../component/config/Constant"
import Form from "../../../component/utilities/Forms";
import "../../../assets/css/form.css";
import axios from 'axios';
import { AuthContext } from '../../../component/context/AuthContext';
import { toast } from "react-toastify";
import DivSpinner from "../../../component/utilities/Spinner";

import DatePicker from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import defaultProfilePhoto from '../../../assets/img/icon/default.png';

function Add() {
	const departmentTeamList = [
		{
			"id": 1,
			"fk_department_id": 1,
			"name": "Developer"
		},
		{
			"id": 2,
			"fk_department_id": 1,
			"name": "Designer"
		},
		{
			"id": 3,
			"fk_department_id": 1,
			"name": "Mobile"
		},
		{
			"id": 4,
			"fk_department_id": 1,
			"name": "QA"
		}
	]
	const [authUserData, setAuthUserData] = useContext(AuthContext);
	const [validate, setValidate] = useState({});
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	// const [address, setAddress] = useState("");
	const [department, setDepartment] = useState("");
	const [teamdepartmentid, setTeamDepartmentId] = useState("");
	const [teamdepartmentList, setTeamDepartmentList] = useState("");
	const [departmentList, setDepartmentList] = useState("");
	const [designation, setDesignation] = useState("");
	const [designationList, setDesignationList] = useState("");
	const [status, setStatus] = useState("");
	const [bloodGroup, setBloodGroup] = useState("");
	const [workStatus, setWorkStatus] = useState("");
	const [informToAll, setInformToAll] = useState(false);
	const [sendInduction, setSendInduction] = useState(false);
	const [loading, setLoading] = useState(false);
	const [checked, setChecked] = useState([]);
	const [dateOfBirth, setDateOfBirth] = useState(new Date());
	const [dateOfJoining, setDateOfJoining] = useState(new Date());
	/* New entires */
	// const [aadharAddress, setAadharAddress] = useState("");
	const [aadharNumber, setAadharNumber] = useState("");
	const [panNumber, setPanNumber] = useState("");
	const [uanNumber, setUanNumber] = useState("");
	const [esicNumber, setEsicNumber] = useState("");
	const [gaurdianRelation, setGaurdianRelation] = useState("");
	const [gaurdianName, setGaurdianName] = useState("");
	const [gaurdianContactNumber, setGaurdianContactNumber] = useState("");

	let isToken = '';
	if (authUserData) {
		if (authUserData[0]) {
			isToken = authUserData[0].token ? authUserData[0].token : "";
		}
	}
	const validateEmployee = async () => {
		let isValid = true;

		let validator = Form.validator({
			firstName: {
				value: firstName,
				isRequired: true,
				isEmail: false,
				label: "first name",
			},
			lastName: {
				value: lastName,
				isRequired: true,
				isEmail: false,
				label: "last name",
			},
			email: {
				value: email,
				isRequired: true,
				isEmail: true,
				label: "email",
			},
			phoneNumber: {
				value: phoneNumber,
				isRequired: true,
				isEmail: false,
				isPhone:true,
				label: "phone number",
			},
			department: {
				value: department,
				isRequired: true,
				isEmail: false,
				label: "department",
			},
			// address: {
			// 	value: address,
			// 	isRequired: true,
			// 	isEmail: false,
			// 	label: "address",
			// },
			bloodGroup: {
				value: bloodGroup,
				isRequired: true,
				isEmail: false,
				label: "Blood Group",
			},
			status: {
				value: status,
				isRequired: true,
				isEmail: false,
				label: "status",
			},
			workStatus: {
				value: workStatus,
				isRequired: true,
				isEmail: false,
				label: "Work Status",
			},
			dateOfBirth: {
				value: dateOfBirth,
				isRequired: true,
				isEmail: false,
				label: "Date of birth",
			},
			dateOfJoining: {
				value: dateOfJoining,
				isRequired: true,
				isEmail: false,
				label: "Date of Joining",
			},
			aadharNumber: {
				value: aadharNumber,
				isRequired: true,
				isEmail: false,
				isAadhar:true,
				label: "Aadhar number",
			},
			panNumber: {
				value: panNumber,
				isRequired: true,
				isEmail: false,
				isPan:true,
				label: "PAN number",
			},
			/* uanNumber: {
			value: uanNumber,
			isRequired: true,
			isEmail: false,
			label: "UAN number",
			}, 
			 esicNumber: {
			 value: esicNumber,
			 isRequired: true,
			 isEmail: false,
			 label: "ESIC number",
			 },
			 */
			gaurdianRelation: {
				value: gaurdianRelation,
				isRequired: true,
				isEmail: false,
				label: "Relation with Gaurdian",
			},
			gaurdianName: {
				value: gaurdianName,
				isRequired: true,
				isEmail: false,
				label: "Gaurdian Name",
			},
			gaurdianContactNumber: {
				value: gaurdianContactNumber,
				isRequired: true,
				isEmail: false,
				isPhone: true,
				label: "Gaurdian Contact Number",
			},
		});

		if (validator !== null) {
			setValidate({
				validate: validator.errors,
			});
			isValid = false;
		} else {
			setValidate({
				validate: "",
			});
			isValid = true;
		}

		// enforce minimum age of 18 years
		if (isValid) {
			const dob = moment(dateOfBirth);
			if (!dob.isValid() || moment().diff(dob, 'years') < 18) {
				setValidate({
					validate: {
						dateOfBirth: ['Employee must be at least 18 years old.'],
					},
				});
				isValid = false;
			}
		}

		return isValid;
	};
	const HandleInfomChecked = async () => {
		setInformToAll(!informToAll);
	}
	const handleInductionChecked = async () => {
		setSendInduction(!sendInduction);
	}
	const handleFrmSubmit = async (e) => {
		e.preventDefault();
		const validate = await validateEmployee();
		if (validate) {
			setLoading(true);
			// await axios
			// 	.post(CONST.EMP_CREATE, {
			try {
				// Step 1: Create employee with basic info
				const employeeResponse = await axios.post(CONST.ADD_EMPLOYEE, {
					first_name: firstName,
					last_name: lastName,
					email: email,
					// address: address,
					department: department,
					designation: designation,
					status: status,
					phone_number: phoneNumber,
					role_id: 4,
					informToAll: informToAll,
					sentEmailtoDept: checked,
					sendInduction: sendInduction,
					login_url: CONST.APP_LINK,
					department_team_id: teamdepartmentid,
					date_of_birth: moment(dateOfBirth).format('YYYY-MM-DD'),
					date_of_joining: moment(dateOfJoining).format('YYYY-MM-DD'),
					pan_number: panNumber,
					uan_number: uanNumber,
					esic_number: esicNumber,
					aadhar_number: aadharNumber,
					work_status: workStatus,
					blood_group: bloodGroup
					// relation_name: gaurdianRelation,
					// guardian_name: gaurdianName,
					// guardian_phone: gaurdianContactNumber
					// profile_photo_path: "/uploads/profile-photos/default.png",
					// profile_photo: "default.png",
				}, {
					headers: {
						'Authorization': `Basic ${isToken}`
					}
				// 	})
				// .then((response) => {

				// 	const status = response.data.status;
				// 	setLoading(false);
				// 	if (status === 'error') {
				// 		const errorMsg = response.data.errors;
				// 		let isArray = Array.isArray(errorMsg);
				// 		if (isArray) {
				// 			errorMsg.map(element => {
				// 				toast.error(element.msg);
				// 			})
				// 		}
				// 		else {
				});

				const employeeStatus = employeeResponse.data.status;
				if (employeeStatus === 'error') {
					const errorMsg = employeeResponse.data.message || employeeResponse.data.errors;
					toast.error(errorMsg);
					// }
					console.log(errorMsg);
					setLoading(false);
					return;
				}

				// Step 2: Get the created user ID
				const userId = employeeResponse.data.data.id;
				if (!userId) {
					toast.error("Employee created but user ID not found. Cannot add guardian details.");
					setLoading(false);
					return;
				}

				// Step 3: Add guardian details if provided
				if (gaurdianName || gaurdianRelation || gaurdianContactNumber) {
					
					try {
						await axios.post(CONST.ADD_GUARDIAN_DETAILS, {
						user_id: userId,   
						guardian: [
							{
							relation_name: gaurdianRelation,
							name: gaurdianName,
							email: '',
							phone: gaurdianContactNumber,
							address: ''
							}
						]
						}, {
						headers: {
							Authorization: `Basic ${isToken}`
						}
						});
						console.log('Guardian details added successfully');
					} catch (guardianError) {
						console.error('Guardian creation error:', guardianError);
						// Don't fail the whole process if guardian fails - employee is already created
						toast.warning("Employee created but guardian details could not be added. Please add them later.");
					}
				}

				toast.success("Employee account has been created successfully.");
				// Reset form fields
				setFirstName("");
				setLastName("");
				setEmail("");
				setPhoneNumber("");
				setDateOfBirth(new Date());
				setDateOfJoining(new Date());
				// setAddress("");
				setDepartment("");
				setDepartmentList("");
				setDesignation("");
				setDesignationList("");
				setTeamDepartmentId("");
				setStatus("");
				setBloodGroup("");
				setWorkStatus("");
				setGaurdianRelation("");
				setGaurdianName("");
				setGaurdianContactNumber("");
				setAadharNumber("");
				setPanNumber("");
				setUanNumber("");
				setEsicNumber("");
				setInformToAll(false);
				setSendInduction(false);
				setChecked([]);
				// 	})
				// .catch((error) => {
				// 	toast.error("Something went wrong. Please try again.");
				// });
			} catch (error) {
				console.error("Error:", error);
				const errorMsg = error.response?.data?.message || "Something went wrong. Please try again.";
				toast.error(errorMsg);
			} finally {
				setLoading(false);
			}
		}
	}
	const handleReset = async () => {
		setFirstName("");
		setLastName("");
		setEmail("");
		setPhoneNumber("");
		// setAddress("");
		setDepartment("");
		setDesignation("");
		setDesignationList("");
		setTeamDepartmentId("")
		setStatus("");
		setInformToAll(false);
		setSendInduction(false);
		setLoading(false);
		setChecked([]);
	}
	const fetchDepartment = async () => {
		await axios
			.get(CONST.GET_DEPARTMENT, {
				headers: {
					'Authorization': `Basic ${isToken}`
				}
			})
			.then((response) => {
				const status = response.data.status;
				if (status === 'success') {
					setDepartmentList(response.data.data);
				}
			})
			.catch((error) => {
				alert(error);
			});
	}
	const fetchTeamDepartment = async () => {
		await axios
			.get(CONST.GET_DEPARTMENT_TEAM_LIST, {
				headers: {
					'Authorization': `Basic ${isToken}`
				}
			})
			.then((response) => {
				const status = response.data.status;
				if (status === 'success') {
					setTeamDepartmentList(response.data.data);
					// setTeamDepartmentList(departmentTeamList);
				}
			})
			.catch((error) => {
				alert(error);
			});
	}
	useEffect(() => {
		fetchDepartment();
		fetchTeamDepartment()
	}, [])
	console.log(departmentList);

	const handleDesignation = async (did) => {
		setLoading(true);
		setDepartment(did);
		if (did) {
			await axios
				.get(CONST.GET_DESIG_BY_ID + '/' + did, {
					headers: {
						'Authorization': `Basic ${isToken}`
					}
				})
				.then((response) => {
					const status = response.data.status;
					if (status === 'success') {
						setDesignationList(response.data.data);
					}
				})
				.catch((error) => {
					alert(error);
				});
		} else {
			setDesignationList("");
		}
		setLoading(false);
	}
	const handleDeptCheck = async (event) => {
		var updatedList = [...checked];
		if (event.target.checked) {
			updatedList = [...checked, event.target.value];
		} else {
			updatedList.splice(checked.indexOf(event.target.value), 1);
		}
		setChecked(updatedList);
	}
	console.log(checked);
	return (
		<>
			<Loading
				loading={loading}
				background="rgba(0, 0, 0, 0.5)"
				loaderColor="#fff"
			/>

			<HeaderSection
				title="Add"
				heading="Employee"
				addButton=""
				addLink={CONST.ADMIN_PRE + 'employee'}
				addLinkName="Employee List"
				linktype="view"
			/>

			<div className="page-body">
				<div className="container-xl">
					<div className="row row-cards">
						<div className="col-12">
							<div className="card">

								<div className="card-body">
									<form
										method="POST"
										onSubmit={handleFrmSubmit}
										autoComplete={"off"}
									>
										<div className="row">
											<label className="form-label"><h5>Personal Information</h5></label>
											<hr />
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">
														First Name
														<span className="text-danger"> * </span>
													</label>
													<div>
														<input
															type="text"
															name="firstName"
															id="firstName"
															className={`form-control ${validate.validate && validate.validate.firstName
																? "is-invalid "
																: ""
																}`}
															aria-describedby="emailHelp"
															placeholder="Enter first name"
															onChange={(e) => setFirstName(e.target.value)}
															value={firstName}
														/>
													</div>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.firstName
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.firstName
															? validate.validate.firstName[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">
														Last Name
														<span className="text-danger"> * </span>
													</label>
													<div>
														<input
															type="text"
															name="lastName"
															id="lastName"
															className={`form-control ${validate.validate && validate.validate.lastName
																? "is-invalid "
																: ""
																}`}
															aria-describedby="emailHelp"
															placeholder="Enter last name"
															onChange={(e) => setLastName(e.target.value)}
															value={lastName}
														/>
													</div>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.lastName
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.lastName
															? validate.validate.lastName[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">Email<span className="text-danger"> * </span></label>
													<div>
														<input
															type="email"
															className={`form-control ${validate.validate && validate.validate.email
																? "is-invalid "
																: ""
																}`}
															id="email"
															name="email"
															value={email}
															placeholder="your@email.com"
															onChange={(e) => setEmail(e.target.value)}
														/>
														<div
															className={`invalid-feedback text-start mb-2 ${validate.validate && validate.validate.email
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.email
																? validate.validate.email[0]
																: ""}
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">
														Phone Number<span className="text-danger"> * </span>
													</label>
													<div>
														<input
															international
															defaultCountry="US"
															type="text"
															name="phoneNumber"
															id="phoneNumber"
															maxLength={'10'}
															className={`form-control ${validate.validate && validate.validate.phoneNumber
																? "is-invalid "
																: ""
																}`}
															aria-describedby="emailHelp"
															placeholder="Enter phone number"
															onChange={(e) => {
																				if (/^[0-9]*$/.test(e.target.value)) {
																				setPhoneNumber(e.target.value);
																				}
																			}}
															value={phoneNumber}
														/>
													</div>
													<div
														className={`invalid-feedback text-start 
															${validate.validate && validate.validate.phoneNumber
																? "d-block"
																: "d-none"
															}
														`}
													>
														{validate.validate && validate.validate.phoneNumber
															? validate.validate.phoneNumber[0]
															: ""}{" "}
													</div>{" "}
													<div
														className="invalid-feedback text-start" >
													</div>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">
														Date of Birth
													</label>
													<div>
														<DatePicker
															name="dateOfBirth"
															id='dateOfBirth'
															value={dateOfBirth}
															selected={dateOfBirth}
															timeFormat=""
															dateFormat="DD-MM-YYYY"
															className={`${validate.validate && validate.validate.dateOfBirth
																? "is-invalid "
																: ""
																}`}
															onChange={(date) => setDateOfBirth(date)}
														/>
													</div>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.dateOfBirth
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.dateOfBirth
															? validate.validate.dateOfBirth[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>
											{/* { 
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">Address</label>
													<div>
														<input
															type="text"
															className={`form-control ${validate.validate && validate.validate.address
																? "is-invalid "
																: ""
																}`}
															id="address"
															name="address"
															value={address}
															placeholder="Enter address"
															onChange={(e) => setAddress(e.target.value)}
														/>
														<div
															className={`invalid-feedback text-start mb-2 ${validate.validate && validate.validate.address
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.address
																? validate.validate.address[0]
																: ""}
														</div>
													</div>
												</div>
											</div> } */}
											<div className="col-md-4">
												<div className="mb-3">
													<label className="form-label required">Department<span className="text-danger"> * </span></label>
													{
														(departmentList) ? (
															<>



																<select
																	className={`form-select form-control ${validate.validate && validate.validate.department
																		? "is-invalid "
																		: ""
																		}`}
																	name="department"
																	id="department"
																	placeholder="Select department"
																	onChange={(e) => handleDesignation(e.target.value)}

																	value={department}
																>
																	<option value="">Select</option>

																	{
																		departmentList && departmentList.map((element, index) => {
																			return (
																				<option
																					value={element.id}
																					key={index}
																				>{element.name}</option>

																			);
																		})
																	}
																</select>
															</>
														) :
															(
																<>
																	<DivSpinner size="sm" color="primary" />
																</>
															)
													}
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.department
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.department
															? validate.validate.department[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>
											{
												designationList &&
												(
													<div className="col-md-4">
														<div className="mb-3">
															<label className="form-label required">Designation</label>
															<select
																className={`form-select form-control ${validate.validate && validate.validate.designation
																	? "is-invalid "
																	: ""
																	}`}
																name="designation"
																id="designation"
																placeholder="Select designation"
																onChange={(e) => setDesignation(e.target.value)}
																value={designation}
															>
																<option value="">Select</option>
																{
																	designationList && designationList.map((element, index) => {
																		return (
																			<option
																				value={element.id}
																				key={index}
																			>{element.name}</option>

																		);
																	})
																}
															</select>
															<div
																className={`invalid-feedback text-start ${validate.validate && validate.validate.designation
																	? "d-block"
																	: "d-none"
																	}`}
															>
																{validate.validate && validate.validate.designation
																	? validate.validate.designation[0]
																	: ""}{" "}
															</div>{" "}
														</div>
													</div>
												)
											}
											<div className="col-md-4">
												<div className="form-group mb-3 ">
													<label className="form-label required">
														Date of Joining
													</label>
													<div>
														<DatePicker
															name="dateOfJoining"
															id='dateOfJoining'
															value={dateOfJoining}
															selected={dateOfJoining}
															timeFormat=""
															dateFormat="DD-MM-YYYY"
															className={`${validate.validate && validate.validate.dateOfJoining
																? "is-invalid "
																: ""
																}`}
															onChange={(date) => setDateOfJoining(date)}
														/>
													</div>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.dateOfJoining
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.dateOfJoining
															? validate.validate.dateOfJoining[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>
											{
												department == '1' &&
												(
													<div className="col-md-4">
														<div className="mb-3">
															<label className="form-label required">Department Team</label>
															<select
																className={`form-select form-control ${validate.validate && validate.validate.designation
																	? "is-invalid "
																	: ""
																	}`}
																name="teamdepartmentid"
																id="teamdepartmentid"
																placeholder="Select designation"
																onChange={(e) => setTeamDepartmentId(e.target.value)}
																value={teamdepartmentid}
															>
																<option value="">Select</option>
																{
																	teamdepartmentList && teamdepartmentList.map((element, index) => {
																		return (
																			<option
																				value={element.id}
																				key={index}
																			>{element.name}</option>

																		);
																	})
																}
															</select>
															<div
																className={`invalid-feedback text-start ${validate.validate && validate.validate.teamdepartmentid
																	? "d-block"
																	: "d-none"
																	}`}
															>
																{validate.validate && validate.validate.teamdepartmentid
																	? validate.validate.teamdepartmentid[0]
																	: ""}{" "}
															</div>{" "}
														</div>
													</div>
												)
											}

											<div className="col-md-4">
												<div className="mb-3">
													<label className="form-label required">Blood Group<span className="text-danger"> * </span></label>
													<select
														className={`form-select form-control ${validate.validate && validate.validate.bloodGroup
															? "is-invalid "
															: ""
															}`}
														name="bloodGroup"
														id="bloodGroup"
														placeholder="Select Blood Group"
														onChange={(e) => setBloodGroup(e.target.value)}
														value={bloodGroup}
													>
														<option value="">Select</option>
														<option value="A+">A+</option>
														<option value="A-">A-</option>
														<option value="B+">B+</option>
														<option value="B+">B-</option>
														<option value="AB+">AB+</option>
														<option value="AB-">AB-</option>
														<option value="O+">O+</option>
														<option value="O-">O-</option>
													</select>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.bloodGroup
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.bloodGroup
															? validate.validate.bloodGroup[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>

											<div className="col-md-4">
												<div className="mb-3">
													<label className="form-label required">Work Status<span className="text-danger"> * </span></label>
													<select
														className={`form-select form-control ${validate.validate && validate.validate.workStatus
															? "is-invalid "
															: ""
															}`}
														name="workStatus"
														id="workStatus"
														placeholder="Select work status"
														onChange={(e) => setWorkStatus(e.target.value)}
														value={workStatus}
													>
														<option value="">Select</option>
														<option value="wfh">WFH</option>
														<option value="wfo">WFO</option>
													</select>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.workStatus
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.workStatus
															? validate.validate.workStatus[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>

											<div className="col-md-4">
												<div className="mb-3">
													<label className="form-label required">Status<span className="text-danger"> * </span></label>
													<select
														className={`form-select form-control ${validate.validate && validate.validate.status
															? "is-invalid "
															: ""
															}`}
														name="status"
														id="status"
														placeholder="Select status"
														onChange={(e) => setStatus(e.target.value)}
														value={status}
													>
														<option value="">Select</option>
														<option value="1">Active</option>
														<option value="0">Deactive</option>
													</select>
													<div
														className={`invalid-feedback text-start ${validate.validate && validate.validate.status
															? "d-block"
															: "d-none"
															}`}
													>
														{validate.validate && validate.validate.status
															? validate.validate.status[0]
															: ""}{" "}
													</div>{" "}
												</div>
											</div>
											{/* Documents Information */}

											<div className="row mt-2 mb-2">
												<div className='col-md-12'>
													<h5>
														Documents Information<hr />
													</h5>
												</div>


												{/* Aadhar Number */}
												<div className="col-md-6">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															Aadhar Number<span className="text-danger"> * </span>
														</label>
														<div>
															<input
																type="text"
																name="aadharNumber"
																id="aadharNumber"
																maxLength={'12'}
																className={`form-control ${validate.validate && validate.validate.aadharNumber
																	? "is-invalid "
																	: ""
																	}`}
																placeholder="Enter aadhar number"
																onChange={(e) => {
																					if (/^[0-9]*$/.test(e.target.value)) {
																					setAadharNumber(e.target.value);
																					}
																				}}
																value={aadharNumber}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.aadharNumber
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.aadharNumber
																? validate.validate.aadharNumber[0]
																: ""}{" "}
														</div>{" "}
													</div>
												</div>
												{/* PAN Number */}
												<div className="col-md-6">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															PAN Number<span className="text-danger"> * </span>
														</label>
														<div>
															<input
																type="text"
																name="panNumber"
																id="panNumber"
																className={`form-control ${validate.validate && validate.validate.panNumber
																	? "is-invalid "
																	: ""
																	}`}
																aria-describedby="emailHelp"
																placeholder="Enter pan number"
																onChange={(e) =>{
																					const value = e.target.value.toUpperCase();
																					if (/^[A-Z0-9]*$/.test(value)) {
																					setPanNumber(value);
																					}
																				}}
																value={panNumber}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.panNumber
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.panNumber
																? validate.validate.panNumber[0]
																: ""}{" "}
														</div>{" "}
													</div>
												</div>
												{/* UAN Number*/}
												<div className="col-md-6">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															UAN Number<span className="text-danger">  </span>
														</label>
														<div>
															<input
																type="text"
																name="uanNumber"
																id="uanNumber"
																className={`form-control ${validate.validate && validate.validate.uanNumber
																	? "is-invalid "
																	: ""
																	}`}
																aria-describedby="emailHelp"
																placeholder="Enter uan number"
																onChange={(e) => setUanNumber(e.target.value)}
																value={uanNumber}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.uanNumber
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.uanNumber
																? validate.validate.uanNumber[0]
																: ""}{" "}
														</div>{" "}



													</div>
												</div>
												{/* ESIC Number */}
												<div className="col-md-6">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															ESIC Number
														</label>
														<div>
															<input
																type="text"
																name="esicNumber"
																id="esicNumber"
																className={`form-control ${validate.validate && validate.validate.esicNumber
																	? "is-invalid "
																	: ""
																	}`}
																aria-describedby="emailHelp"
																placeholder="Enter esic number"
																onChange={(e) => setEsicNumber(e.target.value)}
																value={esicNumber}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.esicNumber
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.esicNumber
																? validate.validate.esicNumber[0]
																: ""}{" "}
														</div>{" "}
													</div>
												</div>
											</div>

											<div className="row mt-2 mb-2">
												<div className='col-md-12'>
													<h5>
														Gaurdian Information<hr/>
													</h5>
												</div>
												<div className="col-md-4">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															Relation with Gaurdian<span className="text-danger"> * </span>
														</label>
														<div>
															<input
																type="text"
																name="gaurdianRelation"
																id="gaurdianRelation"
																className={`form-control ${validate.validate && validate.validate.aadharNumber
																	? "is-invalid "
																	: ""
																	}`}
																placeholder="Enter relation"
																onChange={(e) => setGaurdianRelation(e.target.value)}
																value={gaurdianRelation}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.gaurdianRelation
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.gaurdianRelation
																? validate.validate.gaurdianRelation[0]
																: ""}{" "}
														</div>{" "}
													</div>
												</div>
												<div className="col-md-4">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															Gaurdian Name<span className="text-danger"> * </span>
														</label>
														<div>
															<input
																type="text"
																name="gaurdianName"
																id="gaurdianName"
																className={`form-control ${validate.validate && validate.validate.gaurdianName
																	? "is-invalid "
																	: ""
																	}`}
																placeholder="Name of gaurdian"
																onChange={(e) => setGaurdianName(e.target.value)}
																value={gaurdianName}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.gaurdianName
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.gaurdianName
																? validate.validate.gaurdianName[0]
																: ""}{" "}
														</div>{" "}
													</div>
												</div>
												<div className="col-md-4">
													<div className="form-group mb-3 ">
														<label className="form-label required">
															Gaurdian Contact Number<span className="text-danger"> * </span>
														</label>
														<div>
															<input
																type="text"
																name="gaurdianContactNumber"
																id="gaurdianContactNumber"
																maxLength={'10'}
																className={`form-control ${validate.validate && validate.validate.gaurdianContactNumber
																	? "is-invalid "
																	: ""
																	}`}
																placeholder="Contact number"
																onChange={(e) => {
																					if (/^[0-9]*$/.test(e.target.value)) {
																					setGaurdianContactNumber(e.target.value);
																					}
																				}}
																value={gaurdianContactNumber}
															/>
														</div>
														<div
															className={`invalid-feedback text-start ${validate.validate && validate.validate.gaurdianContactNumber
																? "d-block"
																: "d-none"
																}`}
														>
															{validate.validate && validate.validate.gaurdianContactNumber
																? validate.validate.gaurdianContactNumber[0]
																: ""}{" "}
														</div>{" "}
													</div>
												</div>
											</div>
											<div className='col-md-12'>
												<label className="form-label"><h5>Welcome to eLuminous</h5></label>
												<hr />
											</div>
											<div className="col-md-4">
												<div className="mb-3">
													<input
														type="checkbox"
														className="checkbox"
														name="informToAll"
														id="informToAll"
														placeholder="Select status"
														onChange={(e) => HandleInfomChecked(e.target.value)}
														value={informToAll}
													/>
													<label className="pl-2">Inform to departments?</label>

												</div>
											</div>
											{
												(informToAll) && (
													<>
														<div className='col-md-12 none pl-5' id="informToAllSection">

															<label className="form-label"><h6>Select Departments to which you want to send welcome email</h6></label>
															<div className="row p-0">
																{
																	departmentList && departmentList.map((element, index) => {
																		return (
																			<>
																				<div className="col-xl-3 col-md-4">
																					<div className="mb-3">
																						<input
																							type="checkbox"
																							className="checkbox"
																							name=""
																							id=""
																							placeholder="Select status"
																							onChange={handleDeptCheck}
																							value={element.id}
																						/>
																						<label className="pl-2">{element.name}</label>
																					</div>
																				</div>
																			</>
																		);
																	})
																}


															</div>
														</div>
													</>
												)
											}
											<div className="col-md-12">
												<div className="mb-3">
													<input
														type="checkbox"
														className="checkbox"
														name="sendInduction"
														id="sendInduction"
														onChange={(e) => handleInductionChecked(e.target.value)}
														value={sendInduction}
													/>
													<label className="pl-2">Send Induction?</label>

												</div>
											</div>
											<div className="col-md-12">
												<div className="form-footer">
													<button
														type="submit"
														className="mr-3 btn btn-primary"
													>
														Submit
													</button>
													&nbsp;&nbsp;
													<button
														type="reset"
														className="btn btn-outline-primary"
														onClick={handleReset}
													>
														Reset
													</button>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div >
		</>
	)
}

export default Add